module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"row\">\r\n	<div class=\"add_overflow_y\">\r\n		<table id=\"propMainTable\"></table>\r\n	</div>\r\n	<div id=\"propMainGridButtons\" class=\"\">\r\n		<button type=\"button\" id=\"\" title=\"new\" name=\"itemNew\" class=\"itemNew btn btn-default hvr-glow tbl-icon\">\r\n			<i class=\"fa pf-add\"></i>\r\n		</button>\r\n		<button type=\"button\" id=\"\" title=\"remove\"  name=\"itemRemove\" class=\"itemRemove btn btn-default hvr-glow tbl-icon\">\r\n			<i class=\"fa pf-delete icon-gradient\"></i>\r\n		</button>\r\n	</div>\r\n</div>\r\n\r\n\r\n\r\n")
  }
  return __output;

}